import { RightOutlined } from '@ant-design/icons';

import { Col, Flex, Form, Row, Select } from 'antd';
import { BaseButton } from 'components/button/button-base';
import { Text } from 'components/mvp-typography';
import { useClinicianContext } from 'lib/hooks/use-resolveCurrentClinicInfo';
import { oneThirdCol, selectProps } from 'lib/utils/antd';
import { useEffect } from 'react';
import { theme } from 'styles/colors';

export function ClinicContextForm() {
  const clinicianInfoState = useClinicianContext();
  const [form] = Form.useForm<{ currentClinic: string }>();

  /**
   * Update the form when `clinicianInfoState` changes
   */
  useEffect(() => {
    form.setFieldValue('currentClinic', clinicianInfoState.currentClinic);
  }, [clinicianInfoState.currentClinic, form]);

  return (
    <Row>
      <Col {...oneThirdCol}>
        <Text color={theme.grey.medium}><small>Current organization: {clinicianInfoState.currentClinic?.slice(0, 6)}</small></Text>
      </Col>

      <Col>
        <Form
          form={form}
          onFinish={values => {
            clinicianInfoState.setCurrentClinic(values.currentClinic);
          }}
        >
          <Flex gap={'large'} justify="center">
            <Form.Item
              label="Select organization"
              name="currentClinic"
              rules={[{ required: true }]}
              hasFeedback
            >
              <Select
                {...selectProps}
                style={{
                  minWidth: 200
                }}
                key={clinicianInfoState.currentClinic}
                defaultValue={clinicianInfoState.currentClinic}
                options={clinicianInfoState.clinicIds.map((_, index) => ({
                  label: clinicianInfoState.clinicNames[index],
                  value: _
                }))}
              />
            </Form.Item>
            <div>
              <BaseButton htmlType="submit">
                Apply changes <RightOutlined />
              </BaseButton>
            </div>
          </Flex>
        </Form>
      </Col>
    </Row>
  );
}
